/* Milano Straps - Lingua del visitatore.
   Due comportamenti, mai insieme:
   1) browser in una delle 5 lingue del negozio, diversa da quella servita
      -> PROPONE la traduzione con una striscia (non forza). Rete di sicurezza:
         di norma ci arriva prima il reindirizzamento automatico di Shopify.
   2) browser in una lingua che NON copriamo (giapponese, portoghese, cinese...)
      -> REINDIRIZZA a /en/. Shopify in questo caso non fa niente e il
         visitatore resterebbe sull'italiano, che e' la scelta peggiore.
   Usa gli hreflang gia' presenti in pagina: nessun servizio esterno, nessuna
   URL inventata. Ricorda la scelta e non insiste. */
(function () {
  var SUPPORTED = { it: 1, de: 1, en: 1, fr: 1, es: 1 };
  var BOT = /bot|crawl|spider|slurp|bingpreview|headlesschrome|lighthouse|pagespeed|gtmetrix|facebookexternalhit|embedly|preview/i;

  /* Decisione pura: nessun accesso al DOM, cosi' e' collaudabile.
     Ritorna 'redirect', 'suggest' oppure null. */
  function decide(o) {
    if (!o || o.designMode) return null;
    if (o.userAgent && BOT.test(o.userAgent)) return null;

    var current = String(o.currentLang || '').slice(0, 2).toLowerCase();
    var target = String(o.browserLang || '').slice(0, 2).toLowerCase();

    // Lingua del browser illeggibile: non indovinare, non fare nulla.
    if (!target || !current) return null;
    if (target === current) return null;

    if (SUPPORTED[target]) {
      return o.alreadyAnswered ? null : 'suggest';
    }
    // Lingua non coperta: l'inglese e' il ripiego, ma solo se non ci siamo gia'.
    if (current === 'en') return null;
    return o.alreadyRedirected ? null : 'redirect';
  }

  if (typeof module !== 'undefined' && module.exports) { module.exports = { decide: decide }; return; }

  try {
    var SUGGEST_KEY = 'ms_lang_suggest_v1';
    var REDIRECT_KEY = 'ms_lang_redirect_v1';
    function read(k) { try { return !!localStorage.getItem(k); } catch (e) { return false; } }
    function write(k) { try { localStorage.setItem(k, '1'); } catch (e) {} }

    var path = location.pathname;
    // Non intercettare carrello, cassa, account e percorsi di servizio.
    if (/^\/(cart|checkouts?|account|tools|wpm|\.well-known|apps\/)/.test(path)) return;

    var currentLang = (document.documentElement.lang || 'it').slice(0, 2).toLowerCase();
    var browserLang = (navigator.languages && navigator.languages[0]) || navigator.language || '';

    var action = decide({
      currentLang: currentLang,
      browserLang: browserLang,
      userAgent: navigator.userAgent || '',
      designMode: !!(window.Shopify && window.Shopify.designMode),
      alreadyAnswered: read(SUGGEST_KEY),
      alreadyRedirected: read(REDIRECT_KEY)
    });
    if (!action) return;

    function hrefFor(lang) {
      var link = document.querySelector('link[rel="alternate"][hreflang="' + lang + '"]');
      return link && link.getAttribute('href');
    }

    if (action === 'redirect') {
      var en = hrefFor('en');
      if (!en) return;
      write(REDIRECT_KEY);
      // replace: il tasto indietro resta utilizzabile.
      location.replace(en + location.search + location.hash);
      return;
    }

    var target = String(browserLang).slice(0, 2).toLowerCase();
    var href = hrefFor(target);
    if (!href) return;

    var T = {
      de: { msg: 'Diese Seite ist auch auf Deutsch verfügbar.', yes: 'Auf Deutsch fortfahren', no: 'Nein, danke' },
      en: { msg: 'This page is also available in English.', yes: 'Continue in English', no: 'No, thanks' },
      fr: { msg: 'Cette page est aussi disponible en français.', yes: 'Continuer en français', no: 'Non merci' },
      es: { msg: 'Esta página también está disponible en español.', yes: 'Continuar en español', no: 'No, gracias' },
      it: { msg: 'Questa pagina è disponibile anche in italiano.', yes: 'Continua in italiano', no: 'No, grazie' }
    };
    var t = T[target] || T.en;

    var css = '#ms-lang-suggest{position:fixed;left:0;right:0;bottom:0;z-index:9997;padding-right:96px;background:#1d1b18;color:#f7f5f1;display:flex;align-items:center;gap:16px;flex-wrap:wrap;justify-content:center;padding:14px 20px;font-family:inherit;font-size:14px;line-height:1.3;box-shadow:0 -2px 12px rgba(0,0,0,.18)}#ms-lang-suggest .ms-ls__msg{font-weight:500}#ms-lang-suggest .ms-ls__yes{background:#a51a15;color:#fff;text-decoration:none;padding:9px 18px;font-size:11px;letter-spacing:.14em;text-transform:uppercase;font-weight:700}#ms-lang-suggest .ms-ls__no{background:transparent;border:1px solid rgba(247,245,241,.4);color:#f7f5f1;padding:9px 14px;font-size:11px;letter-spacing:.08em;text-transform:uppercase;cursor:pointer}@media(max-width:600px){#ms-lang-suggest{font-size:13px;padding:12px 14px;gap:10px}}';
    var style = document.createElement('style'); style.textContent = css; document.head.appendChild(style);

    function build() {
      var bar = document.createElement('div');
      bar.id = 'ms-lang-suggest';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Language suggestion');
      var m = document.createElement('span'); m.className = 'ms-ls__msg'; m.textContent = t.msg;
      var y = document.createElement('a'); y.className = 'ms-ls__yes'; y.href = href; y.textContent = t.yes;
      var n = document.createElement('button'); n.type = 'button'; n.className = 'ms-ls__no'; n.textContent = t.no;
      n.addEventListener('click', function () { write(SUGGEST_KEY); bar.parentNode && bar.parentNode.removeChild(bar); });
      y.addEventListener('click', function () { write(SUGGEST_KEY); });
      bar.appendChild(m); bar.appendChild(y); bar.appendChild(n);
      document.body.appendChild(bar);
    }
    // Il banner del consenso occupa la stessa fascia: non lo si copre mai.
    // Si aspetta che sparisca, con un tetto di 45s per non restare appesi.
    function consensoAperto() {
      var b = document.querySelector('#shopify-pc__banner, .shopify-pc__banner, [id^="shopify-pc__banner"]');
      if (!b) return false;
      var cs = getComputedStyle(b);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && b.getBoundingClientRect().height > 0;
    }
    function quandoLibero(fn) {
      var scaduto = Date.now() + 45000;
      (function attendi() {
        if (!consensoAperto()) return fn();
        if (Date.now() > scaduto) return;
        setTimeout(attendi, 500);
      })();
    }
    function avvia() { quandoLibero(build); }
    if (document.body) avvia(); else document.addEventListener('DOMContentLoaded', avvia);
  } catch (e) {}
})();
